export default {
  LOAD_TRANSACTIONS: 'LOAD_TRANSACTIONS',
  SET_NEW_TRANSACTIONS: 'SET_NEW_TRANSACTIONS',
  UPDATE_NEW_TRANSACTIONS: 'UPDATE_NEW_TRANSACTIONS',
  SET_LAST_TRANSACTION: 'SET_LAST_TRANSACTION',
  MARK_ACCOUNT_READ: 'MARK_ACCOUNT_READ',
  LOAD_ACCOUNTS: 'LOAD_ACCOUNTS',
  UPDATE_ACCOUNT: 'UPDATE_ACCOUNT',
  LOAD_CATEGORIES: 'LOAD_CATEGORIES',
  ADD_CATEGORY: 'ADD_CATEGORY',
  DELETE_CATEGORY: 'DELETE_CATEGORY',
  LOAD_PAYEES: 'LOAD_PAYEES',
  LOAD_BANKS: 'LOAD_BANKS',
  SET_PROFILE: 'SET_PROFILE',
  SET_PREFS: 'SET_PREFS',
  MERGE_LOCAL_PREFS: 'MERGE_LOCAL_PREFS',
  MERGE_GLOBAL_PREFS: 'MERGE_GLOBAL_PREFS',
  SET_BUDGETS: 'SET_BUDGETS',
  SET_REMOTE_FILES: 'SET_REMOTE_FILES',
  SET_ALL_FILES: 'SET_ALL_FILES',
  SET_AVAILABLE_IMPORTS: 'SET_AVAILABLE_IMPORTS',
  CLOSE_BUDGET: 'CLOSE_BUDGET',
  SET_APP_STATE: 'SET_APP_STATE',
  DEBUG_CELL: 'DEBUG_CELL',
  PUSH_MODAL: 'PUSH_MODAL',
  REPLACE_MODAL: 'REPLACE_MODAL',
  HIDE_MODALS: 'HIDE_MODALS',
  SHOW_MODALS: 'SHOW_MODALS',
  CLOSE_MODAL: 'CLOSE_MODAL',
  POP_MODAL: 'POP_MODAL',
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
  GET_USER_DATA: 'GET_USER_DATA',
  SET_LAST_UNDO_STATE: 'SET_LAST_UNDO_STATE',
  SET_LAST_SPLIT_STATE: 'SET_LAST_SPLIT_STATE',
  SET_ACCOUNTS_SYNCING: 'SET_ACCOUNTS_SYNCING',
  ACCOUNT_SYNC_STATUS: 'ACCOUNT_SYNC_STATUS',
  ACCOUNT_SYNC_FAILURES: 'ACCOUNT_SYNC_FAILURES',
  SIGN_OUT: 'SIGN_OUT',

  SET_TUTORIAL_STAGE: 'SET_TUTORIAL_STAGE',
  DEACTIVATE_TUTORIAL: 'DEACTIVATE_TUTORIAL'
};
